/**
 * Table Actions component module.
 * @module shared/components/TableActions
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import {Button, DescriptiveText, Row} from '../index';

/**
 * Table Actions component
 * @name TableActions
 */
const TableActions = (props) => {
  const {actions, setTableSelect, selectedRows, dataManager} = props;
  const [selectedAction, setSelectedAction] = React.useState();

  if (!actions.length) {
    return null;
  }

  const selectAction = (name, value) => {
    // const action = actions.find(a => a.label === value.label);
    setSelectedAction(value);
    if (dataManager.toggleAllPageRowsSelected) {
      dataManager.toggleAllPageRowsSelected(false);
    }
    setTableSelect(current => ({...current, ...value.select}));
  };

  return <Row justifySubRow={'left'}>
    <Dropdown onChange={selectAction}
              placeholder={'Actions'}
              options={actions}
              width={'200px'}
              dataPoint={{name: 'updateAction', value: selectedAction}}/>
    {selectedAction && <Button disabled={!(selectedAction && selectedRows.length && Object.keys(selectedRows[0]).length)
    || selectedAction?.select?.max < selectedRows?.length}
                               importance={'primary'}
                               width={'fit-content'}
                               size={'md'}
                               action={() => selectedAction.button.action(selectedRows)}
                               label={selectedAction.button.label}/>}
    {selectedAction && <DescriptiveText>{selectedAction.helpCopy}</DescriptiveText>}
  </Row>;
};

export default TableActions;

TableActions.propTypes = {
  /**
   * Array of actions that can be chosen in a dropdown
   */
  actions: PropTypes.arrayOf(PropTypes.shape({
    /**
     * The label of the action to be displayed in the dropdown
     */
    label: PropTypes.string.isRequired,
    /**
     * The Button displayed when selected
     */
    button: PropTypes.shape({
      /**
       * The button's label
       */
      label: PropTypes.string.isRequired,
      /**
       * The action to take when the button is pressed, it's called with the Selected Rows
       */
      action: PropTypes.func.isRequired,
    }).isRequired,
    /**
     * The Select Input for the Table to be passed to setTableSelect when an action is chosen.
     */
    select: PropTypes.object,
  })).isRequired,
  /**
   * The table's selected rows to be passed to the action when button is pressed
   */
  selectedRows: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * The function called with Action Select when an action is chosen
   */
  setTableSelect: PropTypes.func.isRequired,
  /**
   * Data Manager for the table so that toggleAllPageRowsSelected can be called setting them all to false when action is changed.
   */
  dataManager: PropTypes.shape({toggleAllPageRowsSelected: PropTypes.func}).isRequired,
};
